import { useQuery } from "@tanstack/react-query";
import { useDataProvider } from "ra-core";

import { sumActiveExpenses } from "./expenseScreenRules";
import type { Expense } from "./expenseTypes";

const PAGE_SIZE = 1000;
/** Safety bound: 100 pages is far above the 50K-row scale target. */
const MAX_PAGES = 100;

/**
 * Total MXN of the expenses matching `filter`, cancelled rows excluded. The
 * database (or FakeRest) does the filtering; only the amounts are summed here,
 * page by page, so the header total covers the whole filtered view and not just
 * the visible page.
 */
export const useExpenseTotal = (filter: Record<string, unknown>) => {
  const dataProvider = useDataProvider();
  return useQuery({
    queryKey: ["expenses", "getTotal", filter],
    queryFn: async (): Promise<number> => {
      let total = 0;
      for (let page = 1; page <= MAX_PAGES; page += 1) {
        const result = await dataProvider.getList<Expense>("expenses", {
          filter: { ...filter, is_cancelled: false },
          pagination: { page, perPage: PAGE_SIZE },
          sort: { field: "id", order: "ASC" },
        });
        total = sumActiveExpenses([
          ...result.data,
          { amount_mxn: total, cancelled_at: null },
        ]);
        if (
          result.data.length < PAGE_SIZE ||
          page * PAGE_SIZE >= (result.total ?? 0)
        ) {
          break;
        }
      }
      return total;
    },
  });
};
